// extracted by mini-css-extract-plugin
export default {"disable-scroll":"mobileheader_disable-scroll__JZmpu","dropdown":"mobileheader_dropdown__XQJqa"};